import React from "react";

import logo from '../assets/logo_combined.svg';

import { styles } from './home.styles';

export const HomeScreen = () => (
  <div style={styles.container}>
    <img style={styles.logo} src={logo} alt="logo"/>
    <div>
        <h2>RIA BEL (Pvt) Ltd</h2>
        <h4>It consulting, mobile apps, web apps</h4>
    </div>
    <h3>291/1, Kandy Road</h3>
    <h3>Kiribathgoda, Sri Lanka</h3>
  </div>
);



// WEBPACK FOOTER //
// ./src/screens/home.screen.tsx